import React from "react";
import { Box, styled, Theme, Typography, useMediaQuery } from "@mui/material";

const AccountsHeaderContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

interface Props {
  icon?: React.ReactNode;
  title?: string;
  subtitle?: string;
  nativeCurrency?: string;
}

export const AccountsHeader = ({
  icon,
  title,
  subtitle,
  nativeCurrency,
}: Props) => {
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const titleVariant = isSm ? "h6" : "h4";

  return (
    <AccountsHeaderContainer>
      {icon && (
        <Box mr={4} sx={{ "& img": { display: "block" } }}>
          {icon}
        </Box>
      )}
      <Box>
        {title && (
          <Typography variant={titleVariant} component="h1">
            {title}
            {nativeCurrency && (
              <Typography
                component="span"
                variant={titleVariant}
                color="textSecondary"
                ml={1}
              >
                ({nativeCurrency})
              </Typography>
            )}
          </Typography>
        )}
        {subtitle && (
          <Typography variant={isSm ? "body3" : "body2"} color="textSecondary">
            {subtitle}
          </Typography>
        )}
      </Box>
    </AccountsHeaderContainer>
  );
};
